import { CCPA_SUBDIVISION, GDPR_WEB_LOCALES } from '@/constants/web-locales.constant';
import type { WebLocale } from '@/enums/web-locale';

import Cookies from 'js-cookie';

function hasUCConsentBanner(webLocale: WebLocale) {
	return GDPR_WEB_LOCALES.includes(webLocale) || hasCCPABanner();
}

function hasCCPABanner() {
	const subdivision = Cookies.get('subdivision');

	return CCPA_SUBDIVISION.includes(subdivision!);
}

export { hasUCConsentBanner, hasCCPABanner };
